<fieldset>
 <legend>
  Procedure
 </legend>
 <app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="procedure.autres" 
 
[label]="'autres'"
[type]="'text'" [rule]="''"
[name]="getUid()+'_SepAtt_autres'">
</app-form-input>

<!---->

<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="procedure.procedureAdaptee" 
 
[label]="'procedureAdaptee'"
[type]="'text'" [rule]="''"
[name]="getUid()+'_SepAtt_procedureAdaptee'">
</app-form-input>

<!---->

<fieldset>
 <legend>
  marcheNegocie
 </legend>
 <app-marche-negocie  [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
 [marcheNegocie]="procedure.marcheNegocie"></app-marche-negocie>
</fieldset>

<!---->

<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="procedure.appelOuvert" 
 
[label]="'appelOuvert'"
[type]="'text'" [rule]="''"
[name]="getUid()+'_SepAtt_appelOuvert'">
</app-form-input>

<!---->

<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="procedure.dialogueCompetitif" 
 
[label]="'dialogueCompetitif'"
[type]="'text'" [rule]="''"
[name]="getUid()+'_SepAtt_dialogueCompetitif'">
</app-form-input>

<!---->

<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="procedure.concoursRestreint" 
 
[label]="'concoursRestreint'"
[type]="'text'" [rule]="''"
[name]="getUid()+'_SepAtt_concoursRestreint'">
</app-form-input>

<!---->

<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="procedure.appelRestreint" 
 
[label]="'appelRestreint'"
[type]="'text'" [rule]="''"
[name]="getUid()+'_SepAtt_appelRestreint'">
</app-form-input>

<!---->

<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="procedure.concoursOuvert" 
 
[label]="'concoursOuvert'"
[type]="'text'" [rule]="''"
[name]="getUid()+'_SepAtt_concoursOuvert'">
</app-form-input>
</fieldset>